import React, { useState } from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

import ExpandInfo from "./ExpandInfo";

const Pas10 = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "17.5rem" : "20rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              DEER
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Punerea sub tensiune finală a instalațiilor electrice (inclusiv
            montarea contorului)
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            (Furnizorul ales de tine încheie la rândul său un contract de
            distribuție cu noi, operatorul de distribuție și solicită punerea în
            funcțiune.Acum are loc montarea contorului și punerea în funcțiune a
            instalației de utilizare.)
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            2 zile lucrătoare de la data emiterii certificatului de racordare
          </Typography>

          {/* <Typography variant="h6" sx={{ mt: 5 }}>
            Rambursarea cheltuielilor de racordare
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a href="./DEER-PO-intarire-RED.pdf" style={{ color: "#0D6D92" }}>
              INSTRUCȚIUNE privind stabilirea costurilor aferente lucrărilor de
              întărire generale de care beneficiază mai mulți utilizatori pentru
              racordarea locurilor de producere/locurilor de consum și de
              producere (avizată cu aviz ANRE nr. 64/14.12.2022)
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./DEER-PO-MRC-2.1-Asigurarea-accesului-la-retea.pdf"
              style={{ color: "#0D6D92" }}
            >
              PROCEDURA privind asigurarea accesului la rețea (în curs de
              actualizare)
            </a>
          </Typography> */}

          {/* <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            În conformitate cu prevederile contractului de racordare
          </Typography> */}
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "32rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Pas10;
